var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalLayout',{attrs:{"title":'임직원 구매내역',"mStyle":'width:800px;height:700px; padding:0',"noFooter":true,"full":true},on:{"close":_vm.handleClose}},[_c('PurchaseHistory')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }